import React, { Component, useState, useEffect } from 'react';
import Select from 'react-select';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { debug } from 'util';
import axios from 'axios';
import Configdata from './Defaultdata';
import './home.css';
import Localdata from './Localdata';
import './cube.css';
import { getmessage,sendpostnow,clearform,gtlclstor,setpls,getpls } from './Dynamictable';
import {reducearray,cnvrtdropdown} from './Defaulddbdata';
import { arutyps,citiescodes,arrcomptype,arradvtype,cityidfromcod } from './userdefaultdata';
import {txtnullchk,isvaluenull,isvalidatemail,isvalidmob,isnumber,isdecimal} from './validation';
import Process from './imgs/process.gif';
export default class Posting extends Component {

    constructor(props: any) {
   	super(props);
	
	this.state.slctrent = false;
	this.state.slctsale = false;
	this.state.slctlease = false;
	
	this.state.slctcity = false;
	this.state.slctstate = false;
	this.state.slcthome = false;
	this.state.slctowner = false;
	this.state.slctagent = false;
	this.state.slctland = false;
	this.state.slctfreehold = false;
	this.state.slctjoint = false;
  	}
	
    state = {

	slctrent: true,
	slctsale: false,
        slctlease: false,
	slctcity:false,
	slctstate:false,
	slcthome:false,
	slctland:false,
	slctowner:false,
	slctagent:false,
	slctfreehold:false,
	slctjoint:false,
	slctold:false,
	
	procondition:1,
	described:"",
        name: "World",
        transctype: 1,
        ownership: 1,
	Protype: 1,
        Phone: '',
	isownerentry:1,
	postedby: 'Owner',
        msg: "",
        typeoption: null,
        expoption: null,
        catoption: null,
        bindopt: null,
        isVisible: true,
        resm: null,
        url: "",
      
	propertycode:"",
        tpb: null,
	cityoption:0,
	citycode:'OTH',
        opening: [{}],
	ownerentry: false,
	partnerentry: true,
	provtitle:"",
	localityid:0,
        toggeldtls:false,
        dtlpriceopt:'0.0',
	dtlareaopt:'0',
	dtlfloornoopt:0,
	dtlonflooropt:0,
	dtlageopt:0,
	displaydays:10,
	amnschoolopt:'',
	amnhospitalopt:'',
	amnrailopt:'',
	amnbusstopopt:'',
	homebhk:1,
	localitydata: [{value:0,label:'Other'}],
	cities:[{ value: 'DEL', label: 'Delhi' }],

    };
toggeldetails(e: any){
 
 const isdetail = this.state.toggeldtls;
  const dspldtls = isdetail == false?true:false;
  this.setState({toggeldtls: dspldtls});
   this.detailshow(dspldtls); 
  this.disabledtls();
  const Pdivdtls = document.getElementById('prodtls') as HTMLElement; 
  Pdivdtls.style.display = 'block';	
  		
}
disabledtls(){
 
    const Pdivdtls = document.getElementById('prodtls') as HTMLElement;
    const Pdivamint = document.getElementById('aminitydtls') as HTMLElement;
    Pdivamint.style.display = 'none';
    Pdivdtls.style.display = 'none';

	
}
propertydtlsshow(e: any){

  
  this.disabledtls();
  const Pdivdtls = document.getElementById('prodtls') as HTMLElement; 
  Pdivdtls.style.display = 'block';	
  e.preventDefault()
}
aminitydtlsshow(e: any){

  
  this.disabledtls();
  const Pdivdtls = document.getElementById('aminitydtls') as HTMLElement; 
  Pdivdtls.style.display = 'block';
 
  e.preventDefault()	

}

detailshow(chs: any){
 const Pdivr = document.getElementById('detailsdiv') as HTMLElement;
 if(chs == true) Pdivr.style.display = 'block';
 else Pdivr.style.display = 'none';
	
}
detailsclose(){
const Pdivr = document.getElementById('detailsdiv') as HTMLElement;
Pdivr.style.display = 'none';
}
getlocalitydata(eid: any){
	 try {
          const arg = 'prd=0,' + eid;
        	//alert(arg);
	this.opencloseprocpstng(true);
	axios.get(Configdata.srvurl + '/getcitylocalitis?' + arg)
            .then((response: any) => {
               
		const tdata = response.data;
             
		const d  = reducearray(tdata);
	        const drplocaldata = cnvrtdropdown(d,'pid','plname');
		this.setState({localitydata: drplocaldata});
		 const drpdata = JSON.stringify(drplocaldata);
		setpls(eid,drpdata);
		this.opencloseprocpstng(false);
            })
            .catch((err: any) => {
              //  alert('Something went wrong');
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	

  
    cityChange(event: any) {
        const cityvalue = event.value;
       
        this.setState({ cityoption: cityvalue });
	this.setState({ citycode: cityvalue });
        const cid = cityidfromcod(cityvalue);
	 this.setState({ cityoption: cid });
	 const localdatas = getpls(cid);
	
	 if(localdatas == "NA"){ 
		
		this.getlocalitydata(cid);	
	 }
	 else{
	    	
	      const jsondata = JSON.parse(localdatas);
	      this.setState({localitydata: jsondata});
	}
	
        this.setState({ localityid: 0 });
	
    }
    localityChange(event: any) {
        const lvalue = event.value;
       
        this.setState({ localityid: lvalue });
	
		
    }
	
    Homehitcount() {
              
        try {
          
            //const promiseAwait = fetch(Configdata.srvurl + '/Hitcountinput');
          }
        catch (e) {
            debugger;


        }
    }
  
    setserverurl() {
        debugger;
        const appurl = Configdata.srvurl;
       
        this.setState({ url: appurl });
    }
    componentDidMount() {
       // debugger;
     
        //this.Homehitcount();
        this.setserverurl();
	this.setState({ cities: citiescodes });
	this.opencloseprocpstng(false);
    }
typeselect(e: any){
		
		
		const eid = e.target.id;
		//alert(eid);
		e.target.style.backgroundColor = 'green';
		if(eid == 'rentpro')
		{
		this.desecttypes();
		this.setState({ slctrent: true });
		this.setState({ transctype: 1 });
		this.selectedid('rentpro');
		}
		else if(eid == 'salepro'){
		this.desecttypes();
		this.setState({ slctsale: true });
		this.setState({ transctype: 2 });
		this.selectedid('salepro');
		}
		else if(eid == 'leasepro'){
		this.desecttypes();
		this.setState({ slctlease: true });
		this.setState({ transctype: 3 });
		this.selectedid('leasepro');

		}
		
		else if(eid == 'freeholdpro'){
		this.desectfreejoint();
		this.setState({ slctfreehold: true });
		this.setState({ ownership: 1 });
		this.selectedid('freeholdpro');

		}
		else if(eid == 'jointpro'){
		this.desectfreejoint();
		this.setState({ slctjoint: true });
		this.setState({ ownership: 2 });
		this.selectedid('jointpro');

		
		}
		else if(eid == 'homepro'){
		this.desecthomeland();
		this.setState({ slcthome: true });
		this.setState({ Protype: 1 });
		this.selectedid('homepro');

		}
		else if(eid == 'landpro'){
		this.desecthomeland();
		this.setState({ slctland: true });
		this.setState({ Protype: 2 });
		this.selectedid('landpro');
		
		}

		else if(eid == 'ownerentry'){
		this.desectowneragent();
		this.setState({ slctowner: true });
		this.setState({ isownerentry: 1 });
		this.setState({ postedby: 'Owner' });
		this.selectedid('ownerentry');
		
		}
		else if(eid == 'partnerentry'){
		this.desectowneragent();
		this.setState({ slctagent: true });
		this.setState({ isownerentry: 0 });
		this.setState({ postedby: 'Partner' });
		this.selectedid('partnerentry');
		}
		else if(eid == 'newproperty'){
		this.desectedid('oldproperty');
		this.setState({ procondition: 1 });
		}
		else if(eid == 'oldproperty'){
		this.desectedid('newproperty');
		this.setState({ procondition: 0 });
		}

 
		
		

		e.preventDefault()

	};
	desecthomeland(){

	this.setState({ slcthome: false });
	this.setState({ slctland: false });
	this.desectedid('homepro');
	this.desectedid('landpro');

	}

	desectfreejoint(){
	this.setState({ slctfreehold: false });
	this.setState({ slctjoint: false });
	this.desectedid('freeholdpro');
	this.desectedid('jointpro');

	}
	desectowneragent(){

	this.setState({ slctowner: false });
	this.setState({ slctagent: false });
	this.desectedid('ownerentry');
	this.desectedid('partnerentry');

	}

	desectedid(id: any){
		
	   const selct = document.getElementById(id) as HTMLElement;
	   selct.style.backgroundColor = 'gray';

	}
	selectedid(id: any){
	
	   const selct = document.getElementById(id) as HTMLElement;
	   selct.style.backgroundColor = 'green';
	}

   
    desecttypes(){
		this.setState({ slctrent: false });
		this.setState({ slctsale: false });

		
		this.setState({ slctlease: false });
		
	
		this.desectedid('rentpro');
		this.desectedid('salepro');
		this.desectedid('leasepro');
		
	}
   
    insertproperty(e: any){
	 try {
		if(this.isvalidatedctrls()){
		getmessage('On Process Please wait.....','');
          	const ctcod = this.state.citycode;
               // alert(this.state.localityid);
		const tpid = this.state.Protype;
		const uphn = this.state.Phone;
            	const usrid = localStorage.getItem("id");
                const isonr = this.state.isownerentry;
                const aminityvalues = this.state.amnrailopt + ',' + this.state.amnbusstopopt + ',' + this.state.amnhospitalopt + ',' + 					this.state.amnschoolopt;
		//alert(tpid);
                let ownerenrty = "Owner";
                const ownrship = this.state.ownership == 1?'Free Hold':'Joint';
                const cond = this.state.procondition == 1?'New':'Old';
                if(isonr == 1) ownerenrty = "Partner";	

                const response = axios.post(Configdata.srvurl + '/inserproperty', {
    		uname: this.state.provtitle,
    		uid: usrid,
    		typid: tpid,
                uphone: uphn,
		citcod: ctcod,
		transtid: this.state.transctype,
		isowner: isonr,
		cityid: this.state.cityoption,
		localityid: this.state.localityid,
		descript: this.state.described,
		condition: cond,
		tflors:this.state.dtlfloornoopt,
		flon:this.state.dtlonflooropt,
		age:this.state.dtlageopt,
		contryid:1,
		area:this.state.dtlareaopt,
		price:this.state.dtlpriceopt,
		postedby:this.state.postedby,
		ownership:ownrship,
		available:'',
		verify:'',
		photo:'',
		upin:localStorage.getItem("id"),
		amnvls:aminityvalues,
		bhk:this.state.homebhk
  		}, {
    		    headers: {
      				'Content-Type': 'application/json'
    			      }
  			}
		);
	      
                if(response){
		 response.then((result:any) => {
		const procd = result.data;
                const pcode = 'Code: '+ procd; 
                getmessage('Saved successfully',pcode);
		//const ofid = localStorage.getItem("offerid");
		const strofferid = gtlclstor('offer');
		if(strofferid.length > 0) var ofid = parseInt(strofferid);
	        else ofid = 0;
	        sendpostnow(procd,ofid);
		const vld = clearform('frmposting');		
		// this.setState({ propertycode: procd });

	        });		
              }
		
	    }	
          }
        catch (e) {
            debugger;

        }

	
      	e.preventDefault()


     }	
     titleChange(event: any) {

        const titlevalue = event.target.value;
       
        this.setState({ provtitle: titlevalue });
	event.preventDefault()
    }
    phoneChange(event: any) {

        const phonevalue = event.target.value;
       
        this.setState({ Phone: phonevalue });
	event.preventDefault()
    }
    descriptChange(event: any) {

        const descvalue = event.target.value;
       
        this.setState({ described: descvalue });
	event.preventDefault()
    }
    displaydaysChange(event: any) {

        const daysvalue = event.target.value;
       
        this.setState({ displaydays: daysvalue });
	event.preventDefault()
    }
     displaydaysenable(event: any) {
	
       const txtdisplayday = document.getElementById('txtdisplaydays') as HTMLInputElement;
       
       txtdisplayday.disabled = false;
	txtdisplayday.value =  this.state.displaydays.toString();
	 getmessage('Each day 5 point chargable next to 10 days','');
	event.preventDefault()
    }
	
     dtlaminChange(event: any) {
         const id = event.target.id;
	const elvalue = event.target.value;
	//alert(elvalue);
        if(id == 'txtfloorsno'){
      	 this.setState({ dtlfloornoopt: elvalue });
	 }
	 else if(id == 'txtonfloor'){
		
	    this.setState({ dtlonflooropt: elvalue });
	}
	else if(id == 'txtdtlprice'){
	 this.setState({ dtlpriceopt: elvalue });
	}

	else if(id == 'txtdtlarea'){
	 this.setState({ dtlareaopt: elvalue });
	}
	else if(id == 'txtdtlage'){
	 this.setState({ dtlageopt: elvalue });
	}

	else if(id == 'txtaminhospital'){
	 this.setState({ amnhospitalopt: elvalue });
	}

	else if(id == 'txtaminschool'){
	 this.setState({ amnschoolopt: elvalue });
	}

	else if(id == 'txtaminrail'){
	 this.setState({ amnrailopt: elvalue });
	}
	else if(id == 'txtaminbusstp'){
	 this.setState({ amnbusstopopt: elvalue });
	}
	else if(id == 'txthomebhk'){
	 this.setState({ homebhk: elvalue });
	}
      
        
	event.preventDefault()
    }

  isvalidatedctrls(){
	let isvalidate = true;
	
	if(isvaluenull(this.state.provtitle)){
	  getmessage('Title should not be blanck ','');
	  return false;
	}
	
	else if(isvaluenull(this.state.Phone)){
	  getmessage('Phone No should not be blanck','');
	  return false;
	}
	else if(this.state.citycode == 'OTH'){
	 getmessage('Please select city','');
	  return false;
	}
	else if(this.state.localityid == 0){
	 getmessage('Please select Locality','');
	  return false;
	}
	else if(this.state.dtlpriceopt == '0.0'){
	 getmessage('Please price in detail section','');
	  return false;
	}
	else if(this.state.dtlareaopt == '0'){
	 getmessage('Please area in detail section','');
	  return false;
	}
	else if(!isvalidmob(this.state.Phone)){
	 getmessage('Eneter a 10 digit valid phone no','');
	  return false;

	}
	else if(!isnumber(this.state.dtlfloornoopt)){
		 getmessage('Please enter valid floor no.','');
		return false;
	}
	else if(!isnumber(this.state.dtlonflooropt)){
		 getmessage('Please enter valid on floor.','');
		return false;
	}
	else if(!isnumber(this.state.dtlonflooropt)){
		 getmessage('Please enter valid on floor.','');
		return false;
	}
	else if(!isdecimal(this.state.dtlpriceopt)){
		 getmessage('Please enter valid price.','');
		return false;
	}
	else if(!isdecimal(this.state.dtlareaopt)){
		 getmessage('Please enter valid Area.','');
		return false;
	}
	else if(!isnumber(this.state.dtlageopt)){
		 getmessage('Please no. as age of property.','');
		return false;
	}
	else if(this.state.amnhospitalopt.length > 0){
		
		if(!isdecimal(this.state.amnhospitalopt)){
		 getmessage('Please enter valid distance from  hoispital.','');
		return false;
		}
	}
	else if(this.state.amnschoolopt.length > 0){
		
		if(!isdecimal(this.state.amnschoolopt)){
		 getmessage('Please enter valid distance from  school.','');
		return false;
		}
	}
	else if(this.state.amnrailopt.length > 0){
		
		if(!isdecimal(this.state.amnrailopt)){
		 getmessage('Please enter valid distance from  Railway station.','');
		return false;
		}
	}
	else if(this.state.amnbusstopopt.length > 0){
		
		if(!isdecimal(this.state.amnbusstopopt)){
		 getmessage('Please enter valid distance from  Bus stop','');
		return false;
		}
	}
	return isvalidate;	
    }	

    opencloseprocpstng(opt: any){
		
		const srchlocalitydv = document.getElementById('postlocality') as HTMLElement;
		const prciconedv = document.getElementById('processimg') as HTMLElement;
		if(opt){
		srchlocalitydv.style.width = '94%';
		prciconedv.style.display = 'block';
		}
		else{
		srchlocalitydv.style.width = '100%';
		prciconedv.style.display = 'none';

		}

	};
 
 render() {
          
   
     return (

         <form id="frmposting">
	<div className="per100" id="postmain">
	 <div id= "postingtableouter" className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'93vh'}}>
	  <div className="postingtablediv">

	    <table className="postingtable">
		<tr>
		<td>
			<div className="postingrowdiv">
				
				   <a href="#" id="arent" onClick={e => this.typeselect(e)} title="Rent">

                       			<div className="searchtype" id="rentpro" style={{backgroundColor:'green',width:'27%',marginLeft:'0px'}}>
			  		 Rent	
					</div>
				    </a>
				    <a href="#" onClick={e => this.typeselect(e)} title="Sale">

					<div className="searchtype" id="salepro" style={{backgroundColor:'gray',width:'27%',marginLeft:'3vw'}}>
			  			Sale	
					</div>
				    </a>
		     		
				 <a href="#" onClick={e => this.typeselect(e)} title="Lease">

				<div className="searchtype" id="leasepro" style={{backgroundColor:'gray',width:'28.5%',marginLeft:'0px',float:'right'}}>
			  			Lease	
					</div>
				    </a>

			</div>
			
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdiv">
				
				   <a href="#" id="indentytype" onClick={e => this.typeselect(e)} title="Individual">

                       			<div className="searchtype" id="ownerentry" style={{backgroundColor:'green',marginLeft:'0px'}}>
			  		Owner	
					</div>
				    </a>
				    <a href="#" onClick={e => this.typeselect(e)} title="Member">

					<div className="searchtype" id="partnerentry" style={{backgroundColor:'gray',marginLeft:'0px',float:'right'}}>
			  			Member	
					</div>
				    </a>
		     		

			</div>
			
		</td>
		</tr>
		
		<tr>
		<td>
			<div className="postingrowdiv">
				
				   <a href="#" id="afreeholdtype" onClick={e => this.typeselect(e)} title="Feehold">

                       			<div className="searchtype" id="freeholdpro" style={{backgroundColor:'green',marginLeft:'0px'}}>
			  		 Feehold	
					</div>
				    </a>
				    <a href="#" onClick={e => this.typeselect(e)} title="Partner">

					<div className="searchtype" id="jointpro" style={{backgroundColor:'gray',marginLeft:'0px',float:'right'}}>
			  			Joint	
					</div>
				    </a>
		     		

			</div>
			
		</td>
		</tr>
		

		<tr>
		<td>
			<div className="postingrowdiv">
				
				   <a href="#" id="alandpro" onClick={e => this.typeselect(e)} title="Land">

                       			<div className="searchtype" id="landpro" style={{backgroundColor:'gray',marginLeft:'0px'}}>
			  		 Plot	
					</div>
				    </a>
				    <a href="#" onClick={e => this.typeselect(e)} title="Home">

					<div className="searchtype" id="homepro" style={{backgroundColor:'green',marginLeft:'0px',float:'right'}}>
			  			Home	
					</div>
				    </a>
		     		

			</div>
			
		</td>
		</tr>

		<tr>
		<td>
			<div className="postingrowdiv">
		<input type="text" onChange={e => this.titleChange(e) } placeholder="Enter title" id="txtptitle" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdropdown">
		<Select placeholder="Select city"  onChange={e => this.cityChange(e) } id="ucity" options={this.state.cities} className="postingtxtbox" />

			</div>
		</td>
		</tr>
		<tr>
		<td>
			<div className="postingrowdropdown">
			<div id="postlocality" style={{width:'90%',marginTop:'0px',height:'40px',color:'#000000',float:'left'}}>
<Select placeholder="Select Locality"  onChange={e => this.localityChange(e) } id="ulocality" options={this.state.localitydata} className="postingtxtbox" />
			</div>
		<div id="processimg" style={{width:'4%',marginTop:'10px',height:'50px',color:'#000000',float:'left'}}>
		<img style={{width:'100%',marginTop:'0px',height:'30px',color:'#000000',position:'relative',right:'40%',bottom:'0%'}} src={Process} />
			</div>
			</div>
		</td>
		</tr>
		
		<tr>
		<td>
			<div className="postingrowdiv">
			<input type="text" onChange={e => this.phoneChange(e) } placeholder="Enter Phone No "
			  onKeyPress={(event)=>{
			 if(!/[0-9]/.test(event.key)){
			    event.preventDefault();
			   }
			 }
			}
			 id="txtphno" className="postingtxtbox" />
			</div>
		</td>
		</tr>
		
		<tr>
		<td>
			<div className="postingrowdiv">
				 <a href="#" onClick={e => this.insertproperty(e)} title="Save Property">

					<div className="searchtype" id="btnpost" style={{backgroundColor:'gray',marginLeft:'0px',float:'right'}}>
			  			Submit	
					</div>
				    </a>
				 <a href="#" onClick={e => this.toggeldetails(e)} title="Property Details">

					<div className="searchtype" id="btndetails" style={{backgroundColor:'gray',marginLeft:'0px',float:'left'}}>
			  			Details	
					</div>
				    </a>


			</div>
		      
		</td>
		</tr>
		<tr>
		<td>
			
		</td>
		</tr>

	   </table>
	 </div>		
	</div>
	<div id="detailsdiv" className="pro-details" style={{width:'75vw',display:'none',maxHeight:'50vh'}}>
			<div className="per100">
			 <div className="search-title-bar">
                       	<div className="search-title">
			  Fill Prperty Details 
			</div>
			<a href="#" onClick={this.detailsclose} title="Close Details">
			<div className="search-title-toggle" id="toggleclosedts">
			  X
			</div>
			</a>
	   	     </div>
		    <div className="Sikaamsgbody">
			<div className="postingrowdiv">
			<span style={{width:'50%',float:'left'}}>
		   <input type="button" onClick ={e => this.propertydtlsshow(e) } value="Property details" id="btndtlsh" className="postingtxtbox" />
			</span>
			<span style={{width:'50%',float:'right'}}>
		       <input type="button" onClick={e => this.aminitydtlsshow(e) } value="Aminit destance" id="btnamnsh" className="postingtxtbox" />
			</span>
			</div>
                  <div id="prodtls"  style={{width:'100%',height:'auto'}}>
			<div className="postingrowdiv">
		       <span style={{width:'50%',float:'left'}}>
		        <input type="text" onChange={e => this.dtlaminChange(e) } placeholder="Floors no" id="txtfloorsno" className="postingtxtbox" />
			</span>
			<span style={{width:'50%',float:'right'}}>
		        <input type="text" onChange={e => this.dtlaminChange(e) } placeholder="On floor" id="txtonfloor" className="postingtxtbox" />
			</span>
			</div>
			<div className="postingrowdiv">
		       <span style={{width:'50%',float:'left'}}>
		       <input type="text" onChange={e => this.dtlaminChange(e) } placeholder="Price Laks" id="txtdtlprice" className="postingtxtbox" />
			</span>
			<span style={{width:'50%',float:'right'}}>
		        <input type="text" onChange={e => this.dtlaminChange(e) } placeholder="Area Sft" id="txtdtlarea" className="postingtxtbox" />
			</span>
			</div>

			<div className="postingrowdiv" style={{padding:'0px'}}>
			<span style={{width:'100%',float:'left',paddingLeft:'10px'}}>
		<input type="text" onChange={e => this.descriptChange(e) } style={{margin:'0px',width:'97%'}}   placeholder="Describe" id="txtdescript" 		className="postingtxtbox" />
			</span>
			
		        </div>

			<div className="postingrowdiv">
		       <span style={{width:'50%',float:'left'}}>
			<span style={{width:'45%',float:'left',marginLeft:'1%'}}>
		       <input type="text" onChange={e => this.dtlaminChange(e) } placeholder="Prt Age" id="txtdtlage" className="postingtxtbox" />
			</span>
			<span style={{width:'45%',float:'left'}}>
		        <input type="text" onChange={e => this.dtlaminChange(e) } placeholder="BHK" id="txthomebhk" className="postingtxtbox" />
			</span>
			</span>
			<span style={{width:'50%',float:'right'}}>
			<a href="#" id="newconditiontype" onClick={e => this.typeselect(e)} title="New Property">	
		        <span className='new-property' id='newproperty' >New</span>
			</a>
			<a href="#" id="oldcondition" onClick={e => this.typeselect(e)} title="Old Prooperty">
		        <span className='old-property' id='oldproperty'>Old</span>
			</a>
			<a href="#" onClick={this.detailsclose} className="profile-items"  style={{float:'left',color:'ffffff'}}>
		         OK
			</a>
			</span>
			</div>

	       </div>
	       <div id="aminitydtls" style={{width:'100%',height:'auto'}}>
			<div className="postingrowdiv">
		<span style={{width:'50%',float:'left'}}>
		       <input type="text" onChange={e => this.dtlaminChange(e) } placeholder="Hospital" id="txtaminhospital" className="postingtxtbox" />
			</span>
			<span style={{width:'50%',float:'right'}}>
		       <input type="text" onChange={e => this.dtlaminChange(e) } placeholder="School" id="txtaminschool" className="postingtxtbox" />
			</span>
			</div>
			<div className="postingrowdiv">
		<span style={{width:'50%',float:'left'}}>
		        <input type="text" onChange={e => this.dtlaminChange(e) } placeholder="Rail station" id="txtaminrail" className="postingtxtbox" />
			</span>
			<span style={{width:'50%',float:'right'}}>
		        <input type="text" onChange={e => this.dtlaminChange(e) } placeholder="Bus stop" id="txtaminbusstp" className="postingtxtbox" />
			</span>
			</div>
	            </div>	
			<div className="postingrowdiv">
		<span style={{width:'50%',float:'left'}}>
		      
			</span>
			
			</div>
		    </div>
		
	     </div>
          </div>
	<div id= "postingtableinner" className="postingouterdiv" style={{overflowX:'hidden',overflowY:'auto',height:'auto',display:'none'}}>
		<div className="postingtablediv">
		    <table className="postingtable">
		     <tr>
		      <td>
			<div className="postingrowdiv" style={{width:'49%',float:'left'}}>
		<input type="text" onChange={e => this.displaydaysChange(e) } placeholder="Post display 10 days free" id="txtdisplaydays" className="postingtxtbox" disabled/>
			</div>
			<div className="postingrowdiv" style={{width:'49%',float:'left'}}>
			 <input type="button" onClick={e => this.displaydaysenable(e) } value="More 10" id="btndisplaydays" style={{height:'35px'}} className="postingtxtbox"/>
			</div>
			
		      </td>
		     </tr>
		    <tr>
		<td>
			
			
		</td>
		</tr>
	
		    </table>
		</div>	
	</div>
   </div>
   </form>
    
   
  );
}
}

